import { Add } from "@mui/icons-material";
import { Button, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import TabComp from "src/components/shared/TabComp";
import { CHECK_ORDER_BULK_PREPARE, CHECK_ORDER_DELIVERY_ALL, orderStatusFormatted } from "src/constant";
import PrepareBulkPage from "./prepare-bulk";
import useQueryParams from "src/hooks/useQueryParams";
import AllOrderTable from "./all-order";
import OrderSummary from "./all-order/OrderSummary";
import DeliveryAllPage from "./delivery-all";
import useCountOrderTabs from "src/hooks/orders/useCountOrderTabs";
import useAuthGlobal from "src/context/useAuthGlobal";
import useRedirect from "src/helper/direct";
import { KeyboardDoubleArrowUp, KeyboardDoubleArrowDown } from "@mui/icons-material";
import BulkReturnProcessing from "./bulk-return-processing";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function OrdersTable() {
  const permissionCheck = useRoleCheck();
  const redirect = useRedirect();
  const { userMe } = useAuthGlobal();
  const [option] = useQueryParams();
  const [isOpenOrderSummary, setIsOpenOrderSummary] = useState(true);
  const { data: counts, mutate } = useCountOrderTabs({
    warehouse: userMe?.currentWarehouse?._id,
    tab: "New",
  });

  const tabs = counts?.data
    ? [
        {
          id: "all",
          name: `Tất cả ĐH (${counts?.data["Total"]})`,
          subName: "Tất cả đơn hàng",
        },
        {
          id: orderStatusFormatted.WaitToExport,
          name: `Chuẩn bị hàng (${counts?.data[orderStatusFormatted.WaitToExport]})`,
          subName: "Chuẩn bị hàng",
        },
        {
          id: orderStatusFormatted.ReadyToPick,
          name: `Chờ lấy hàng (${counts?.data[orderStatusFormatted.ReadyToPick]})`,
          subName: "Chờ lấy hàng",
        },
        {
          id: orderStatusFormatted.Delivering,
          name: `Đang giao (${counts?.data[orderStatusFormatted.Delivering]})`,
          subName: "Đang giao",
        },
        {
          id: orderStatusFormatted.Delivered,
          name: `Đã giao (${counts?.data[orderStatusFormatted.Delivered]})`,
          subName: "Đã giao thành công",
        },
        {
          id: orderStatusFormatted.Manual,
          name: `Trả hàng/ Hoàn tiền (${counts?.data["TotalReturn"]})`,
          subName: "Trả hàng/ Hoàn tiền",
          childTab: orderStatusFormatted.Returning,
        },
        {
          id: orderStatusFormatted.Exchange,
          name: `Đổi hàng (${counts?.data["TotalExchange"]})`,
          subName: "Đơn đổi hàng",
          childTab: orderStatusFormatted.WaitToExport,
        },
        {
          id: orderStatusFormatted.Canceled,
          name: `Đơn hủy (${counts?.data[orderStatusFormatted.Canceled]})`,
          subName: "Đơn đã hủy",
        },
        {
          id: orderStatusFormatted.DeliveredFailed,
          name: `Giao không TC (${counts?.data["TotalDeliveredFailed"]})`,
          subName: "Giao hàng không thành công",
          childTab: orderStatusFormatted.all,
        },
      ]
    : [];

  const createOrder = () => {
    redirect("/order/create");
  };

  return (
    <>
      <Stack
        gap={1.5}
        mb={1}
      >
        <PageHeader name="Quản lý Đơn Hàng" />
        <Button
          sx={{ display: "flex", maxWidth: "180px", ml: "auto", fontSize: "10px" }}
          onClick={() => setIsOpenOrderSummary((prev) => !prev)}
          endIcon={!isOpenOrderSummary ? <KeyboardDoubleArrowUp /> : <KeyboardDoubleArrowDown />}
        >
          {!isOpenOrderSummary ? "Mở" : "Ẩn"} thống kê
        </Button>
        <Collapse in={isOpenOrderSummary}>
          <OrderSummary />
        </Collapse>
        {![CHECK_ORDER_BULK_PREPARE.prepareBulk, CHECK_ORDER_DELIVERY_ALL.deliverryAll, CHECK_ORDER_DELIVERY_ALL.BulkReturnProcessing]?.includes(option.tab) && (
          <Button
            disabled={!permissionCheck([PERMISSIONS.CREATE_ORDER_ALL, PERMISSIONS.CREATE_ORDER_OWN])}
            onClick={createOrder}
            variant="contained"
            startIcon={<Add />}
            sx={{
              whiteSpace: "nowrap",
              display: "flex",
              alignSelf: "flex-start",
            }}
          >
            Tạo đơn hàng
          </Button>
        )}
        <Typography fontWeight="bold">
          {option?.total < 10 ? "0" + option?.total : option?.total} {!!option?.total ? "đơn hàng" : ""}
        </Typography>
      </Stack>
      {![CHECK_ORDER_DELIVERY_ALL.deliverryAll, CHECK_ORDER_BULK_PREPARE.prepareBulk, CHECK_ORDER_DELIVERY_ALL.BulkReturnProcessing]?.includes(option.tab) && (
        <TabComp tabs={tabs} />
      )}
      {![CHECK_ORDER_DELIVERY_ALL.deliverryAll, CHECK_ORDER_BULK_PREPARE.prepareBulk, CHECK_ORDER_DELIVERY_ALL.BulkReturnProcessing]?.includes(option.tab) && (
        <AllOrderTable warehouseId={userMe?.currentWarehouse?._id} mutate={mutate} />
      )}

      {option.tab === CHECK_ORDER_DELIVERY_ALL.deliverryAll && <DeliveryAllPage mutate={mutate} />}
      {option.tab === CHECK_ORDER_BULK_PREPARE.prepareBulk && <PrepareBulkPage mutate={mutate} />}
      {option.tab === CHECK_ORDER_DELIVERY_ALL.BulkReturnProcessing && <BulkReturnProcessing warehouseId={userMe?.currentWarehouse?._id} mutate={mutate} />}
    </>
  );
}
